import { createAction } from '@reduxjs/toolkit';

export const freeTextSearch = createAction<string>('search/FREE_TEXT_SEARCH');
export const suggestionSearch = createAction<{ query: string; suggestionType?: string }>('search/SUGGESTION_SEARCH');

export const brandsChanged = createAction<number[]>('search/BRANDS_CHANGED');
export const categoryChanged = createAction<{ id: number | null; parentId?: number }>('search/CATEGORIES_CHANGED');
export const filtersReset = createAction<null>('search/FILTERS_RESET');

export const searchItemClick = createAction<{ index: number }>('search/SEARCH_ITEM_CLICK');
